import React from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import withHooks from "../../Common/jsx/WithHooks"
import { FR, GB } from "country-flag-icons/react/3x2"

class Splash extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = { isReadyToRender: true }

    this.dMgr.debug("init_state:", this.state)
  }

  componentDidMount() {
    // this.getEntities()
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <>
        <Row className="text-center">
          <Col className="background-color-black padding-bottom-15 padding-top-15">
            <h1 className="color1">Brainy Games</h1>
            <h3 className="color2">{this.props.t("app.subTitle")}</h3>
          </Col>
        </Row>
        <Row className="margin-top-50">
          <Col md={12} className="text-center ">
            <Button
              className="width-100 button-color2 margin-left-8 margin-top-8"
              onMouseOver={() => {
                this.props.changeLanguage("fr")
              }}
              onClick={() => {
                this.props.router.nav({ url: "/play" })
              }}
            >
              Jouer
              <FR className="margin-top-8 width-50" />
            </Button>
            <Button
              className="width-100 button-color2 margin-left-8 margin-top-8"
              onMouseOver={() => {
                this.props.changeLanguage("en")
              }}
              onClick={() => {
                this.props.router.nav({ url: "/play" })
              }}
            >
              Play <GB className="margin-top-8 width-50" />
            </Button>
          </Col>
        </Row>
      </>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(Splash)
